import { handleHideModal } from 'components/global/_helpers/global.helpers';
import SimpleModal from 'components/global/SimpleModal';
import { $form, $view } from 'signals/global.signals';
import InvestorDealForm from 'components/global/InvestorDealForm';
import { handleSubmitEditDealflow } from 'components/views/InvestorDealflow/_helpers/investorDealflow.events';

const InvestorDealflowEdit = () => (
  <SimpleModal
    show={$view.value?.activeModal === 'investor-dealflow-edit'}
    title={`Edit ${$form.value.name}`}
    isLoading={$view.value?.isModalLoading}
    onHide={handleHideModal}
    onPrimaryClick={() => handleSubmitEditDealflow($form.value.id)}
    primaryButtonText="Save"
    secondaryButtonText="Cancel"
    onSecondaryClick={handleHideModal}
    size="xl"
  >
    <InvestorDealForm />
  </SimpleModal>

);

export default InvestorDealflowEdit;
